import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {EqualValidator} from '../core/directives/equal-validator.directive';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {PageComponent} from './components/page/page.component';
import {PaginationComponent} from './components/pagination/pagination.component';
import {TypeAheadComponent} from './components/type-ahead/type-ahead.component';
import {NoContentComponent} from './components/no-content/no-content.component';
import {TreeViewSelectComponent} from './components/tree-view-select/tree-view-select.component';
import {RmsTzFormatPipe} from './pipes/rms-tz-format.pipe';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {NgSelectModule} from '@ng-select/ng-select';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        RouterModule,
        SweetAlert2Module,
        TranslateModule.forChild(),
        NgSelectModule,
    ],
    exports: [
        CommonModule,
        EqualValidator,
        FormsModule,
        NgbModule,
        NoContentComponent,
        PageComponent,
        PaginationComponent,
        RmsTzFormatPipe,
        RouterModule,
        SidebarComponent,
        SweetAlert2Module,
        TranslateModule,
        TreeViewSelectComponent,
        TypeAheadComponent,
    ],
    declarations: [
        EqualValidator,
        NoContentComponent,
        PageComponent,
        PaginationComponent,
        RmsTzFormatPipe,
        SidebarComponent,
        TreeViewSelectComponent,
        TypeAheadComponent,
    ]
})
export class SharedModule {
}
